import { Form } from 'react-bootstrap';
import styled from 'styled-components';

export const ErrorFeedback = styled(Form.Control.Feedback)`
  display: block;
  margin-top: 0.25rem;
  color: var(--bs-red);
`;

export const InputDescription = styled(Form.Control.Feedback).attrs({
  className: 'text-muted',
})`
  display: block;
  margin-top: 0.25rem;
  text-align: left;
`;

export const Checkbox = styled(Form.Check)`
  input:disabled {
    cursor: not-allowed;
    pointer-events: auto;
  }
`;

export const RadioButton = styled(Form.Check)`
  input:disabled {
    cursor: not-allowed;
    pointer-events: auto;
  }
  input.form-check-input {
    margin-left: 0;
    margin-right: 8px;
  }
  input.form-check-input: checked {
    color: #ffaaaa;
    border-color: #ffaaaa;
  }
  accent-color: #232323;
  border-radius: 8px;
  padding: 0 0;
  border: 6px solid rgba(255, 240, 240, 0);
  &:hover {
    border: 6px solid rgba(255, 240, 240, 1);
    cursor: pointer;
    background-color: rgba(255, 240, 240, 1);
  }
  transition: background-color 0.4s ease-in-out border 0.4s ease-in-out;
`;

export const RadioCardLabel = styled.label`
  padding: 16px;
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 0.375rem;
  border: ${({ $isChecked }) => ($isChecked ? '1px solid #be1622' : '1px solid #ced4da')};
  cursor: pointer;
`;

export const RadioCardHeading = styled.div`
  font-size: 1rem;
`;

export const RadioCardDescription = styled.div`
  font-size: 0.875rem;
  color: #6c757d;
`;

export const RadioCardCheckedIcon = styled.i`
  color: #be1622;
  font-size: 1.25rem;
  position: absolute;
  top: 12px;
  right: 12px;
`;

export const Dropzone = styled.div`
  border: 1px dotted #d2ddec;
  outline: none;
  height: 100px;
  padding: 16px;
  position: relative;
  border-radius: 0.375rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  p {
    font-size: 13px;
    width: 100%;
    margin: 0;
  }

  &:hover {
    background-color: var(--bs-primary-5);
  }
`;

export const PreviewThumbnailWrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin: 1rem 0;
`;

export const FilePreviewThumbnail = styled.div`
  padding-right: 40px;
  overflow-wrap: break-word;
  position: relative;

  button {
    position: absolute;
    top: -8px;
    right: -10px;
    border: 1px solid #cccccc;
  }
`;

export const Input = styled.div`
  display: flex;
  width: 100%;
  input {
    &:disabled {
      border: 1px solid #ced4da;
      background-color: #fbfbfb;
      color: #6c757d;
      cursor: not-allowed;
      opacity: 1;
    }

    ${({ mask }) =>
      mask &&
      `
        border: none;
        font-weight: bold;
        :hover {
          cursor: pointer;
          background-color: #e9ecef;
        }

        :focus {
          border: 1px solid #ced4da;
          :hover {
            cursor: pointer;
            background-color: transparent;
          }
        }
      `}
  }
`;

export const MarkdownEditor = styled.div`
  display: flex;
  flex: 1;
  width: 100%;

  .w-md-editor {
    --color-canvas-default: #fff;
    --color-canvas-subtle: #fff;
    --color-fg-default: #000;
    --color-fg-muted: #000;
    --color-fg-subtle: #999;
    --md-editor-background-color: #fff;
    --md-editor-box-shadow-color: #ced4da;
    width: 100%;
    background: #fff;
    border: 1px solid #ced4da;
    border-radius: 4px;
    box-shadow: none;
    color: #000;
    font-family: inherit;
    transition:
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
  }

  .w-md-editor:focus-within {
    border: 1px solid #be1622;
    outline: none;
  }

  .w-md-editor.is-invalid {
    border-color: var(--bs-red);
  }

  .w-md-editor-toolbar {
    background: #fff;
    border-bottom: 1px solid #ced4da;
    border-radius: 4px 4px 0 0;
  }

  .w-md-editor-toolbar li > button {
    color: #000;
  }

  .w-md-editor-toolbar li > button:hover,
  .w-md-editor-toolbar li > button:focus {
    color: #000;
  }

  .w-md-editor-text,
  .w-md-editor-preview {
    background: #fff;
    color: #000;
    padding: 12px 20px;
    font-family: inherit;
    font-size: 14px;
    line-height: 1.5;
  }

  .w-md-editor-text-input::placeholder {
    color: #999;
  }
`;

export const Caption = styled.div`
  min-height: 150px;
  border: 1.5px dashed;
`;
